<!-- eslint-disable max-len -->
<template>
  <div class="subscribe-button" :class="isSubscribed ? 'subscribed' : ''">
    <div v-if="subscribable" class="subscribe-button-wrap" @click.stop="toggleSubscription">
      <span v-if="isSubscribed" class="subscribed-btn">已订阅</span>
      <span v-else class="subscribe-btn">
        <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 16 16" fill="none">
          <path
            d="M12.6251 11.125L11.8751 9.425V7C11.8751 5.4 10.8501 3.95 9.37506 3.375C9.32506 2.675 8.72506 2.125 8.00006 2.125C7.27506 2.125 6.70006 2.675 6.62506 3.375C5.12506 3.95 4.12506 5.4 4.12506 7V9.425L3.37506 11.125C3.27506 11.35 3.30006 11.6 3.42506 11.8C3.55006 12 3.77506 12.125 4.02506 12.125H11.9751C12.2251 12.125 12.4501 12 12.5751 11.8C12.7001 11.6 12.7251 11.325 12.6251 11.125ZM8.00006 13.75C8.70006 13.75 9.25006 13.2 9.25006 12.5H6.75006C6.75006 13.2 7.30006 13.75 8.00006 13.75Z"
            fill="currentColor"
          /></svg
        ><span>订阅</span>
      </span>
    </div>
  </div>
</template>

<script>
import SubscribeMixin from './SubscribeMixin';

export default {
  name: 'SubscribeButton',
  mixins: [SubscribeMixin],
};
</script>

<style scoped lang="less">
.subscribe-button-wrap {
  position: relative;
  margin-left: 0.08rem;
  font-weight: 500;
  font-size: 0.24rem;
  line-height: 0.32rem;

  &::after {
    position: absolute;
    top: -0.66em;
    right: -0.66em;
    bottom: -0.66em;
    left: -0.66em;
    content: '';
  }

  .subscribed-btn {
    margin-left: 0.04rem;
    color: var(--atom-color-text-quaternary);
  }

  .subscribe-btn {
    display: flex;
    align-items: center;
    white-space: nowrap;
    color: var(--atom-color-red);

    & > svg {
      font-size: 0.32rem;
    }
  }
}
</style>
